exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".marker {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 18px;\n    height: 18px;\n    background-color: #000;\n    border: 2px solid #fff;\n    border-radius: 100%;\n    user-select: none;\n    transform: translate(-50%, -50%);\n  }\n\n  .marker:hover{\n    z-index: 1;\n  }\n\n  .centerMark{\n    top: 50%;\n    left: 50%;\n    position: absolute;\n    transform: translate(-50%, -50%);\n  }", ""]);

// exports
